import React from 'react';
import classnames from 'classnames';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import Heading from '@wix/da-shared-react/pkg/a11y/headings/Heading';

import cssVars from '@wix/da-ds/src/styles/variables.scss';
import profilesCssVars from '../../../../styles/variables.scss';
import s from './WidgetHeaderMobile.scss';

export interface Props {
  header: string | React.ReactNode;
  count?: number | string;
  extras?: React.ReactNode | React.ReactNode[];
  extrasWhenSticky?: React.ReactNode | React.ReactNode[];
  isSticky?: boolean;
  className?: string;
  rootClassName?: string;
  isWide?: boolean;
}

export class WidgetHeaderMobile extends React.Component<Props> {
  render() {
    const { className, isSticky } = this.props;

    // T42244: The sticky headers get stuck a pixel too low sometimes
    const marginTop =
      parseInt(cssVars['site-header-height-mobile']) +
      parseInt(profilesCssVars['mobile-navbar-height']) -
      1;
    return (
      <div className={classnames(s['wrapper'], className)}>
        {isSticky ? (
          <Sticky className={'sticky'} marginTop={marginTop}>
            {isStuck => this.renderInner(isStuck)}
          </Sticky>
        ) : (
          this.renderInner()
        )}
      </div>
    );
  }
  renderInner(isStuck = false) {
    const {
      header,
      count,
      extras,
      extrasWhenSticky,
      rootClassName,
      isWide = false,
    } = this.props;
    const shouldRenderAsHeading = !!header;
    const Tag = shouldRenderAsHeading ? Heading : 'div';
    return (
      <div
        className={classnames(
          s['root'],
          isStuck && s['is-stuck'],
          isWide && s['is-wide'],
          rootClassName
        )}
      >
        <Tag className={s['header']} data-hook={BiDataHook.WIDGET_HEADER}>
          {header}
          {!!count && (
            <span
              className={s['count']}
              data-hook={BiDataHook.WIDGET_HEADER_COUNTER}
            >
              {shortenNumber(count)}
            </span>
          )}
        </Tag>
        {extras}
        {isStuck && extrasWhenSticky}
      </div>
    );
  }
}

export default WidgetHeaderMobile;
